export default {
  methods: {
    videoSet: function (opt, url) {
      const zh = 'zh'
      const en = 'en'
      if (this.lang === zh) {
        opt.language = zh
        opt.sources = [{
          type: 'video/mp4',
          src: this.$url.VIDEOLINKZH[url]
        }]
      } else if (this.lang === en) {
        opt.language = zh
        opt.sources = [{
          type: 'video/mp4',
          src: this.$url.VIDEOLINKEN[url]
        }]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/nknVideoMix.js